import { Languages } from "../../../enums/languages";

const cancelPermitModalLang = {
    "modal-title": {
        [Languages.Hebrew]: { default: "ביטול תו חניה" },
        [Languages.Arabic]: { default: "إلغاء تصريح الانتظار" },
        [Languages.English]: { default: "Cancel Parking Permit" }
    },
    "cancellation-message": {
        [Languages.Hebrew]: { default: "תו החניה בוטל בהצלחה." },
        [Languages.Arabic]: { default: "تم إلغاء تصريح الانتظار بنجاح." },
        [Languages.English]: { default: "The parking permit has been successfully canceled." }
    }
};

export default cancelPermitModalLang;